import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import BreadCrumbStyles from './breadCrumbStyles';

const BreadCrumb = forwardRef((props, ref) => {
  return (
    <BreadCrumbStyles ref={ref} {...props}>
      {props.children}
    </BreadCrumbStyles>
  );
});

BreadCrumb.propTypes = {
  fluid: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

BreadCrumb.defaultProps = {
  fluid: false,
};

const Item = forwardRef((props, ref) => {
  return <BreadCrumbStyles.ItemStyles ref={ref}>{props.children}</BreadCrumbStyles.ItemStyles>;
});

Item.propTypes = {
  children: PropTypes.node.isRequired,
};

BreadCrumb.Item = Item;

export default BreadCrumb;
